import React from "react";
import { BELL, PHOTO } from "../../../assets";

function Header({
  setSideNavVisible,
}: {
  setSideNavVisible: (visible: boolean) => void;
}) {
  return (
    <div className="w-full px-4 pt-4 pb-2 border-b border-[#E9EAEB] flex items-center justify-between">
      <div className="flex flex-col items-start">
        <span className="text=[#2A2A2A] font-semibold text-lg">
          Hi Ademola,{" "}
        </span>
        <span className="text-sm font-medium text-[#9A9A9A]">
          Tuesday May 2, 2023
        </span>
      </div>
      <div className="flex items-center gap-3">
        <div className="relative">
          <img src={BELL} className="w-[21.75px] h-[24.16px]" alt="" />
          <div className="w-[9px] h-[9px] bg-[#CE201A] rounded-full absolute right-0 top-0" />
        </div>

        <div className="flex items-center gap-x-2">
          <img src={PHOTO} className="w-[41px] h-[41px] rounded-full" alt="" />
          <div className="flex flex-col">
            <span className="text-[#2A2A2A] font-semibold text-sm">
              Ademola Samuel
            </span>
            <span className="text-[#9A9A9A] font-medium text-xs">
              Ademolas@gmail.com
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
